import React from 'react';
import { Button } from '@mui/material';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';

const InstructorTrainingPopupModal: React.FunctionComponent<ModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      title={'Instructors'}
      maxWidth={'sm'}
      onClose={onClose}
      disableBackdropClick={true}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} onClick={onClose}>
            {'Close'}
          </Button>
          <Button color={'secondary'} variant={'outlined'} target='_blank' href='https://learning.nccer.org/auth/oauth2/login.php?id=1&reset=1&wantsurl=https://learning.nccer.org'>
            {'Go To Learning Platform'}
          </Button>
        </>
      }
    >
      As an instructor, only the Instructor Recertification course is required to maintain your instructor certification. You will not lose access to the system if you do not complete any additional courses that may have been assigned to you.
    </Modal>
  );
};
export default InstructorTrainingPopupModal;
